import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { Translatable } from "@totalenergiescode/mobility-business-rev-form-data/lib";

import { prettifyJson } from "@/components/FormData/shared/json";
import { useTranslationFailures } from "@/components/FormData/shared/translation/useTranslationFailures";

interface TranslationFailureIndicatorProps {
  targetId: string | Translatable;
}

const TranslationFailureIndicator = ({
  targetId,
}: TranslationFailureIndicatorProps) => {
  const failures = useTranslationFailures(
    typeof targetId === "string" ? targetId : targetId.getTranslationFragment(),
  );
  const { debug } = useFormDataContext();

  if (!debug) {
    return null;
  }

  if (failures.length == 0) {
    return null;
  }

  return (
    <div>
      ⚠️ {failures.length} missing translations:
      <ul>
        {failures.map((failure, index) => (
          <li key={index}>
            <pre>Candidate keys by order:</pre>
            <ul>
              {failure.keys.map((key, index) => (
                <li key={index}>{key}</li>
              ))}
            </ul>
            {failure.params ? (
              <pre>Params: {prettifyJson(failure.params ?? {})}</pre>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TranslationFailureIndicator;
